module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Passive Aggressive Notes: Painfully Polite and Hilariously Hostile Writings")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "FMTitle"
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocSb"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Cover",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COVER")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Title",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TITLE PAGE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Dedication",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DEDICATION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "fm1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Epigraph#fm1a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EPIGRAPH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter001#ch1a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BACK STORY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ch2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter002#ch2a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE NOTES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ch3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter003#ch3a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CO-CONSPIRATORS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ata"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Abouttheauthor#ataa",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ABOUT THE AUTHOR")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "prai"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Praise#prai1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PRAISE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "cpy"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Copyright#cpya",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COPYRIGHT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "abtp"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Aboutthepublisher#abtp1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ABOUT THE PUBLISHER")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772d7f8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 69
// module chunks = 0